<div *ngIf="state.appLoading$ | async" class="loader center">
  <mat-spinner></mat-spinner>
</div>